import { Head } from '@inertiajs/react'
import { Button, Card, Badge } from '@/components/ui'

export default function StyleGuide() {
  return (
    <>
      <Head title="Charte Graphique - Tessan" />
      <div className="min-h-screen bg-bg-page p-8">
        <h1 className="font-heading text-4xl font-bold mb-8">Charte Graphique Tessan</h1>

        {/* Couleurs */}
        <section className="mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Couleurs</h2>
          <div className="flex flex-wrap gap-4">
            <ColorSwatch color="bg-tessan-green" label="Green" hex="#0F352D" />
            <ColorSwatch color="bg-tessan-green-hover" label="Green Hover" hex="#1d5c4d" />
            <ColorSwatch color="bg-tessan-cream" label="Cream" hex="#fcf5cc" />
            <ColorSwatch color="bg-tessan-yellow" label="Yellow" hex="#FFF198" />
            <ColorSwatch color="bg-tessan-yellow-cta" label="Yellow CTA" hex="#feee80" />
            <ColorSwatch color="bg-success" label="Success" hex="#238700" />
            <ColorSwatch color="bg-error" label="Error" hex="#dc2626" />
            <ColorSwatch color="bg-warning" label="Warning" hex="#f59e0b" />
          </div>
        </section>

        {/* Typography */}
        <section className="mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Typographie</h2>
          <div className="space-y-4 bg-white p-6 rounded-xl">
            <h1 className="font-heading text-5xl font-bold">H1 - Recoleta Bold (48px)</h1>
            <h2 className="font-heading text-4xl font-semibold">H2 - Recoleta SemiBold (36px)</h2>
            <h3 className="font-heading text-2xl font-medium">H3 - Recoleta Medium (24px)</h3>
            <h4 className="font-heading text-xl">H4 - Recoleta Regular (20px)</h4>
            <p className="font-sans text-base">Body - Plus Jakarta Sans Regular (16px)</p>
            <p className="font-sans text-sm text-text-secondary">Small - Plus Jakarta Sans Secondary (14px)</p>
            <p className="font-sans text-xs text-text-muted">Muted - Plus Jakarta Sans Muted (12px)</p>
          </div>
        </section>

        {/* Boutons */}
        <section className="mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Boutons</h2>
          <div className="flex flex-wrap gap-4 items-center">
            <Button variant="primary">Primary</Button>
            <Button variant="secondary">Secondary</Button>
            <Button variant="outline">Outline</Button>
            <Button variant="danger">Danger</Button>
            <Button variant="primary" disabled>Disabled</Button>
          </div>
        </section>

        {/* Badges */}
        <section className="mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Badges Gamification</h2>
          <div className="flex flex-wrap gap-4">
            <Badge variant="earned" emoji="🌟" label="Favori" />
            <Badge variant="earned" emoji="🏃" label="Marathonien" />
            <Badge variant="earned" emoji="💬" label="Bavard" />
            <Badge variant="highlight" emoji="⚡" label="Hyperactif" />
            <Badge variant="highlight" emoji="🏆" label="Champion" />
            <Badge variant="locked" emoji="🔒" label="Verrouillé" />
          </div>
        </section>

        {/* Cards */}
        <section className="mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Cards</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Card>
              <h3 className="font-heading text-xl font-semibold mb-2">Card Standard</h3>
              <p className="text-text-secondary">Contenu avec la police Plus Jakarta Sans pour le corps de texte.</p>
            </Card>
            <Card className="bg-tessan-cream border-tessan-green/20">
              <h3 className="font-heading text-xl font-semibold mb-2">Card Accent</h3>
              <p className="text-tessan-green">Fond crème Tessan pour les highlights.</p>
            </Card>
            <Card className="border-tessan-green border-2">
              <h3 className="font-heading text-xl font-semibold mb-2">Card Outlined</h3>
              <p className="text-text-secondary">Bordure vert Tessan pour l'emphase.</p>
            </Card>
          </div>
        </section>

        {/* Status */}
        <section className="mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Status</h2>
          <div className="flex flex-wrap gap-4">
            <span className="px-4 py-2 bg-success/10 text-success rounded-lg font-medium">
              Succès
            </span>
            <span className="px-4 py-2 bg-warning/10 text-warning rounded-lg font-medium">
              Attention
            </span>
            <span className="px-4 py-2 bg-error/10 text-error rounded-lg font-medium">
              Erreur
            </span>
          </div>
        </section>
      </div>
    </>
  )
}

function ColorSwatch({ color, label, hex }: { color: string; label: string; hex: string }) {
  return (
    <div className="text-center">
      <div className={`w-20 h-20 ${color} rounded-lg shadow-sm border border-gray-200`} />
      <div className="text-sm font-medium mt-2">{label}</div>
      <div className="text-xs text-text-muted">{hex}</div>
    </div>
  )
}
